// Business Unit types and constants

export const BUSINESS_UNITS = [
  { value: 'us', label: 'Estados Unidos', flag: '🇺🇸' },
  { value: 'br', label: 'Brasil', flag: '🇧🇷' },
  { value: 'shared', label: 'Compartilhado', flag: '🔗' },
] as const;

export type BusinessUnit = typeof BUSINESS_UNITS[number]['value'];

export const getBusinessUnitLabel = (value: string | null | undefined): string => {
  if (!value) return '';
  const bu = BUSINESS_UNITS.find(b => b.value === value);
  return bu ? bu.label : value;
};

export const getBusinessUnitFlag = (value: string | null | undefined): string => {
  if (!value) return '';
  const bu = BUSINESS_UNITS.find(b => b.value === value);
  return bu ? bu.flag : '';
};

export const getBusinessUnitWithFlag = (value: string | null | undefined): string => {
  if (!value) return '';
  const bu = BUSINESS_UNITS.find(b => b.value === value);
  return bu ? `${bu.flag} ${bu.label}` : value;
};
